<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" closable mask-closable
    :okText="getTranslation('k115')" :cancelText="getTranslation('b182')" :title="getTranslation('k115')" width="35">
    <Row class="field-line warning-title" type="flex" >
      <Col flex="5" style="text-align: left;">
        {{ getTranslation('k111') }}
      </Col>
    </Row>
    <Row class="limit-line" type="flex">
      <Col flex="1" class="left-program desc-field">{{ getTranslation('k112') }}
      </Col>
      <Col flex="4">
      <Upload name="file" :action="softwareUpgrade" :before-upload="handleUpload" :show-upload-list="true" accept=".bin"
        :default-file-list="fileList" :on-remove="handleRemove">
        <div style="padding: 0 0" class="menu-actions">
          <Button icon="ios-cloud-upload-outline" type="info">{{ getTranslation('k114') }}</Button>
        </div>
      </Upload>
      </Col>
    </Row>
    <Row class="limit-line " type="flex">
      <Col flex="1" class="left-program desc-field">{{ getTranslation('m203') }}
      </Col>
      <Col flex="4">
      <Input class="input-field" type="password" v-model="softPassword" />
      </Col>
    </Row>
     <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="success" @click="ok" icon="ios-cloud-upload-outline" >{{ getTranslation('k115') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Button, Upload,Input } from 'view-design';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'

export default {
  name: 'MachineUpgrade', // 组件名称
  components: {
    Modal, Row, Col, Button, Upload,Input
  },
  props: {
    propVisible: Boolean,
    selectedItems: Array,
  },
  data() {
    return {
      modalLoading: true,
      backupList: [],
      selectedParams: [],
      selectedBackup: null,
      fileList: [],
      softPassword:'',
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
    softwareUpgrade() {
      return API_URL["machineSoftwareUpgrade"];
    },
    webSocketUrl() {
      return API_URL['webSocket'];
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.init();
      }
    }
  },

  created() {

  },
  methods: {
    init() {


    },
    async ok() {      
      this.modalLoading = true;
      if (this.fileList.length === 0) {
        this.$Message.warning(this.getTranslation('m103'));
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      if (this.selectedItems.length === 0) {
        this.$Message.warning(this.getTranslation('m094'));
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      const url = API_URL["machineSoftwareUpgrade"];
      const formData = new FormData();
      formData.append('mac', this.selectedItems.join(','));
      formData.append('file', this.fileList[0]);      
      formData.append('password', this.softPassword);
      const res = await axios.post(url,
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },             
      }).catch((err) => {
        postJsError(err)
        this.$Message.error(this.getTranslation('c001'));
      })

      if (res && res.data && res.data.code == 200) {
        this.$emit('start-upgrade',this.fileList);
        this.fileList = [];        
        this.visible = false;
        this.softPassword = "";
        this.$Message.success(res.data.msg);
      } else {
        this.$Message.error(res.data.msg || this.getTranslation('c001'));
      }
      this.softPassword = '';
      this.modalLoading = false;
      this.resetModal();

    },
    handleUpload(file) {
      // 将文件添加到文件列表
      this.fileList = [file];
      // 返回 false 阻止自动上传，但文件会显示在列表中
      return false;
    },
    handleRemove() {
      // 当用户点击删除按钮时，清空文件列表
      this.fileList = [];
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.fileList = [];
      this.visible = false;
    },

  }
}
</script>

<style scoped>
.input-field {
  width: 30%;
}
.warning-title {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  color: #856404;
  font-weight: bold;
  padding: 8px;
  text-align: center;
  margin-bottom: 8px;
}
</style>